import React, { Component } from "react";
import { Route, Switch } from "react-router-dom";
import { connect } from "react-redux";

import { setAuth } from "../actions/";
import Dashboard from "./dashboard/Dashboard";
import { Loader } from "./Loader";

import Modules from "./dashboard/Modules";

import Moderation from "./dashboard/modules/Moderation";
import Announcements from "./dashboard/modules/Announcements";
import CustomCommands from "./dashboard/modules/CustomCommands";
// import MemeCreator from "./dashboard/modules/MemeCreator";
import Fortnite from "./dashboard/modules/Fortnite";
import ApexLegends from "./dashboard/modules/ApexLegends";
import Settings from "./dashboard/modules/Settings";
import Translator from "./dashboard/modules/Translator";
import Weather from "./dashboard/modules/Weather";
import Search from "./dashboard/modules/Search";
import Trivia from "./dashboard/modules/Trivia";
import AutoMod from "./dashboard/modules/AutoMod";
import AutoRole from "./dashboard/modules/AutoRole";
import Twitch from "./dashboard/modules/Twitch";
import YouTube from "./dashboard/modules/YouTube";
import Twitter from "./dashboard/modules/Twitter";
import Reddit from "./dashboard/modules/Reddit";
import Music from "./dashboard/modules/Music";
import Usage from "./dashboard/modules/Usage";
import TimedMessages from "./dashboard/modules/TimedMessages";
import ReactionRoles from "./dashboard/modules/ReactionRoles";
import Economy from "./dashboard/modules/Economy";
import Levels from "./dashboard/modules/Levels";
import CoCreate from "./dashboard/modules/CoCreate";
import Botlist from "./dashboard/modules/Botlist";
import Premium from "./dashboard/modules/Premium";
import Status from "./dashboard/modules/Status";
import NewBot from "./dashboard/modules/NewBot";
import Invite from "./dashboard/modules/Invite";
import StatsChannels from "./dashboard/modules/StatsChannels";
import Giveaways from "./dashboard/modules/Giveaways";
import ErrorBoundary from "./dashboard/elements/ErrorBoundary";
import ReactGA from "react-ga";
import Affiliate from "./dashboard/modules/Affiliate";
import Support from "./dashboard/modules/Support";
import Errors from "./dashboard/modules/Errors";
import FreeHosting from "./dashboard/modules/FreeHosting";
import Server_FreeHosting from "./dashboard/modules/Server_FreeHosting";
import SlashCommands from "./dashboard/modules/SlashCommands";
import Servers from "./dashboard/modules/Servers";
import CommandBuilder from "./dashboard/commandbuilder/CommandBuilder";
import AutoResponder from "./dashboard/modules/AutoResponder";
import Twitter_FreePremium from "./dashboard/modules/Twitter_FreePremium";
import Logging from "./dashboard/modules/Logging";
import Crypto from "./dashboard/modules/Crypto";
import OpenSea from "./dashboard/modules/OpenSea";
import NFTs from "./dashboard/modules/NFTs";
import Tickets from "./dashboard/modules/Tickets";
import BuilderEmbed from "./dashboard/modules/EmbedBuilder";
import DataStorage from "./dashboard/modules/DataStorage";
import CustomEvents from "./dashboard/modules/CustomEvents";
import ActiveDevBadge from "./dashboard/modules/ActiveDevBadge";
import history from "../history";
import CustomModule from "./dashboard/modules/CustomModule";
import NewModules from "./dashboard/NewModules";
import Gifting from "./dashboard/modules/Gifting";
import Webhooks from "./dashboard/modules/Webhooks";
import TimedEvents from "./dashboard/modules/TimedEvents";
import IFTTTLink from "./dashboard/modules/IFTTTLink";
import IFTTT from "./dashboard/modules/IFTTT";
import CoCreateUpdate from "./dashboard/modules/CoCreateUpdate";
import Collaborate from "./dashboard/modules/Collaborate";
import CollabInvite from "./dashboard/modules/CollabInvite";
import server from "../api/server";
import PremiumVoting from "./dashboard/modules/PremiumVoting";
import PrioHosting from "./dashboard/modules/PrioHosting";
import PrioLoadingScreen from "./dashboard/modules/PrioLoadingScreen";
import PremiumTesting from "./dashboard/modules/PremiumTesting";
import PremiumUpgradeScreen from "./dashboard/modules/PremiumUpgradeScreen";

class App extends Component {
	constructor(props) {
		super(props);
		this.state = {
			whitelist: false
		};
		this.whitelistInterval = null;
	}

	componentDidMount() {
		this.props.setAuth();
		ReactGA.initialize("UA-122665050-1", {
			gaOptions: {
				cookieDomain: "auto"
			}
		});

		if (process.env.REACT_APP_WHITELIST_MODE === "true") {
			this.checkWhiteList();

			this.whitelistInterval = setInterval(() => {
				this.checkWhiteList();
			}, 30 * 60 * 1000); // 30 minutes
		}

		console.log(process.env.REACT_APP_WHITELIST_MODE, "WHITELIST MODE");
		// ReactGA.set({ referrer: 'https://botghost.com' })
	}

	componentWillUnmount() {
		// Clear the interval when component unmounts
		if (this.whitelistInterval) {
			clearInterval(this.whitelistInterval);
		}
	}

	checkWhiteList = async () => {
		try {
			const response = await server.get("/dashboard/whitelist-check");
			this.setState({ whitelist: !response.data.whitelisted });
		} catch (error) {
			console.error("Failed to check whitelist status:", error);
			this.setState({ whitelist: true }); // Default to showing access denied screen on error
		}
	};

	render() {
		if (this.state.whitelist) {
			return (
				<div className="min-h-screen bg-[#111111] flex flex-col">
					{/* Header with logo */}
					<div className="bg-[#1A1A2E] py-6 border-b border-[#00ffe0]">
						<div className="max-w-7xl mx-auto px-4">
							<div className="flex justify-center">
								<img src={process.env.PUBLIC_URL + '/images/logo-red.png'} alt="BotGhost Logo" className="h-10" />
							</div>
						</div>
					</div>

					{/* Main content */}
					<div className="flex-grow flex items-center justify-center px-4 py-8">
						<div className="w-full max-w-6xl mx-auto">
							{/* Main container */}
							<div className="bg-gradient-to-br from-[#1A1A2E] to-[#1F2D2B] rounded-xl p-8 border border-[#00ffe0] shadow-lg">
								{/* Status section */}
								<div className="mb-10 text-center">
									<div className="inline-block bg-[#FF4B4B] text-white px-4 py-2 rounded-full text-sm font-bold mb-4">
										ACCESS RESTRICTED
									</div>
									<h2 className="text-4xl font-bold text-white mb-4">
										Alpha Dashboard Access
									</h2>
									<p className="text-[#00ffe0] text-xl">
										This area is exclusively available to our priority users
									</p>
								</div>

								{/* Main image */}
								<div className="mb-10 flex justify-center">
									<div className="relative">
										<div className="overflow-hidden shadow-xl">
											<img
												src={process.env.PUBLIC_URL + '/images/icons/prio_hosting_role.png'}
												onError={(e) => {
													e.target.onerror = null;
													e.target.src = "/img/logo-white.png";
												}}
												alt="Priority Hosting"
												className="w-64 h-64 object-contain"
											/>
										</div>

										{/* Floating stars decoration */}
										<div className="absolute top-0 left-0 w-full h-full pointer-events-none">
											<div className="absolute top-2 right-[5%] text-[#00ffe0] text-3xl animate-pulse delay-100">✦</div>
											<div className="absolute top-16 right-[15%] text-[#00ffe0] text-2xl animate-pulse delay-300">✧</div>
											<div className="absolute top-4 right-[25%] text-[#00ffe0] text-3xl animate-pulse delay-500">✦</div>
											<div className="absolute bottom-20 left-[15%] text-[#00ffe0] text-2xl animate-pulse delay-700">✧</div>
										</div>
									</div>
								</div>

								{/* Requirements list */}
								<div className="mb-10">
									<div className="flex justify-center mb-6">
										<div className="bg-[#0039CB] text-2xl text-white font-medium text-center py-2 px-6 rounded-md">
											Access Requirements
										</div>
									</div>
									<div className="space-y-4 max-w-xl mx-auto mb-8">
										<div className="flex items-center text-[#AAAAAA] text-lg bg-[#1E1E30] p-4 rounded-lg border-l-4 border-[#00ffe0]">
											<svg className="w-6 h-6 mr-3 text-[#00ffe0]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
												<path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7"></path>
											</svg>
											<span className="font-medium text-white">Priority Hosting</span><span className="ml-1 text-[#CCCCCC]">subscription</span>
										</div>
										<div className="flex items-center text-[#AAAAAA] text-lg bg-[#1E1E30] p-4 rounded-lg border-l-4 border-[#00ffe0]">
											<svg className="w-6 h-6 mr-3 text-[#00ffe0]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
												<path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7"></path>
											</svg>
											<span className="font-medium text-white">Alpha Tester</span><span className="ml-1 text-[#CCCCCC]">status</span>
										</div>
									</div>

									{/* Buttons */}
									<div className="flex flex-col sm:flex-row justify-center gap-4">
										<a
											href="https://dashboard.botghost.com/dashboard/priohosting"
											className="flex items-center justify-center bg-gradient-to-r from-[#00ffe0] to-[#00ccb3] hover:from-[#00ccb3] hover:to-[#00ffe0] text-black text-lg font-medium px-8 py-3 rounded-lg transition-all duration-200 hover:shadow-lg"
										>
											Get Priority Hosting
										</a>
										<a
											href="https://discord.gg/botghost"
											className="flex items-center justify-center bg-[#5865F2] hover:bg-[#4752c4] text-white text-lg font-medium px-8 py-3 rounded-lg transition-all duration-200 hover:shadow-lg"
										>
											Join Our Discord
										</a>
									</div>
								</div>

								{/* Info message */}
								<div className="text-center text-[#00ffe0] text-sm">
									<p>Our alpha dashboard provides exclusive features and performance improvements.</p>
									<p className="mt-1">Get access today by subscribing to Priority Hosting.</p>
								</div>
							</div>
						</div>
					</div>

					{/* Footer */}
					<div className="bg-[#1A1A2E] py-4 border-t border-[#00ffe0]">
						<div className="max-w-7xl mx-auto px-4">
							<div className="text-center text-[#00ffe0] text-sm">
								© {new Date().getFullYear()} BotGhost - All Rights Reserved
							</div>
						</div>
					</div>
				</div>
			);
		}
		return (
			<ErrorBoundary>
				<Switch>
					<Route exact path="/dashboard/new" component={NewBot}></Route>
					<Route exact path="/dashboard/modules" component={Modules}></Route>
					<Route exact path="/dashboard/moderation" component={Moderation}></Route>
					{/* <Route exact path="/dashboard/announcements" component={Announcements}></Route> */}
					<Route exact path="/dashboard/automod" component={AutoMod}></Route>
					<Route exact path="/dashboard/customcommands" component={SlashCommands}></Route>
					{/* <Route exact path="/dashboard/textcommands" component={CustomCommands}></Route> */}
					{/* <Route exact path="/dashboard/auto-role" component={AutoRole}></Route> */}
					{/* <Route exact path="/dashboard/usage" component={Usage}></Route> */}
					<Route exact path="/dashboard/giveaways" component={Giveaways}></Route>
					{/* <Route exact path="/dashboard/timedmessages" component={TimedMessages}></Route> */}
					{/* <Route exact path="/dashboard/reactionroles" component={ReactionRoles}></Route> */}
					{/* <Route exact path="/dashboard/youtube" component={YouTube}></Route> */}
					{/* <Route exact path="/dashboard/twitter" component={Twitter}></Route> */}
					{/* <Route exact path="/dashboard/reddit" component={Reddit}></Route> */}
					{/* <Route exact path="/dashboard/twitch" component={Twitch}></Route> */}
					{/* <Route exact path="/dashboard/memecreator" component={MemeCreator}></Route> */}
					{/* <Route exact path="/dashboard/levels" component={Levels}></Route> */}
					<Route
						exact
						path="/dashboard/music"
						component={() => {
							window.location.href = "https://www.youtube.com/watch?v=dQw4w9WgXcQ";
							return null;
						}}
					></Route>
					<Route exact path="/dashboard/economy" component={Economy}></Route>
					{/* <Route exact path="/dashboard/trivia" component={Trivia}></Route> */}
					{/* <Route exact path="/dashboard/search" component={Search}></Route> */}
					{/* <Route exact path="/dashboard/weather" component={Weather}></Route> */}
					<Route exact path="/dashboard/autoresponder" component={AutoResponder}></Route>
					{/* <Route exact path="/dashboard/translator" component={Translator}></Route> */}
					{/* <Route exact path="/dashboard/fortnite" component={Fortnite}></Route> */}
					{/* <Route exact path="/dashboard/apexlegends" component={ApexLegends}></Route> */}
					<Route exact path="/dashboard/settings" component={Settings}></Route>
					<Route exact path="/dashboard/premium" component={PremiumTesting}></Route>
					{/* <Route exact path="/dashboard/premium" component={PremiumTesting}></Route> */}
					<Route exact path="/dashboard/premium-testing" component={PremiumTesting}></Route>
					<Route exact path="/dashboard/premium-upgrade-processing" component={PremiumUpgradeScreen}></Route>
					{/* <Route exact path="/dashboard/cocreate" component={CoCreateUpdate}></Route> */}
					{/* <Route exact path="/dashboard/botlist" component={Botlist}></Route> */}

					{/* HERE1 */}
					{/* <Route exact path="/dashboard/serverpremium" component={Server_FreeHosting}></Route> */}
					{/* <Route exact path="/dashboard/twitterpremium" component={Twitter_FreePremium}></Route> */}
					{/* <Route exact path="/dashboard/tickets" component={Tickets}></Route> */}

					{/* HERE1 */}
					{/* <Route exact path="/dashboard/freepremium" component={Server_FreeHosting}></Route> */}
					{/* <Route exact path="/dashboard/referrals" component={Affiliate}></Route> */}
					<Route exact path="/dashboard/errors" component={Errors}></Route>
					{/* <Route exact path="/dashboard/statisticschannels" component={StatsChannels}></Route> */}
					{/* <Route exact path="/dashboard/crypto" component={Crypto}></Route>
					<Route exact path="/dashboard/openseaalerts" component={OpenSea}></Route>
					<Route exact path="/dashboard/nfts" component={NFTs}></Route> */}
					<Route exact path="/dashboard/webhooks" component={Webhooks}></Route>
					<Route exact path="/dashboard/timedevents" component={TimedEvents}></Route>
					<Route exact path="/dashboard/status" component={Status}></Route>
					<Route exact path="/invite/:id" component={Invite}></Route>
					<Route exact path="/collab/:id" component={CollabInvite}></Route>
					<Route exact path="/dashboard/support" component={Support}></Route>
					<Route exact path="/dashboard/servers" component={Servers}></Route>
					<Route exact path="/dashboard/slashcommands" component={SlashCommands}></Route>
					<Route exact path="/dashboard/builder" component={CommandBuilder}></Route>
					<Route exact path="/dashboard/logging" component={Logging}></Route>
					<Route exact path="/dashboard/embedbuilder" component={BuilderEmbed}></Route>
					<Route exact path="/dashboard/datastorage" component={DataStorage}></Route>
					<Route exact path="/dashboard/customevents" component={CustomEvents}></Route>
					<Route exact path="/dashboard/activedeveloperbadge" component={ActiveDevBadge}></Route>
					<Route exact path={`/dashboard/module/:id/:name`} component={CustomModule}></Route>
					<Route exact path={`/dashboard/gifting`} component={Gifting}></Route>
					<Route exact path={`/dashboard/ifttt/link`} component={IFTTTLink}></Route>
					<Route exact path={`/dashboard/ifttt/`} component={IFTTT}></Route>
					<Route exact path={`/dashboard/collab`} component={Collaborate}></Route>
					<Route exact path={`/dashboard/premiumvoting`} component={PremiumVoting}></Route>
					<Route exact path={`/dashboard/priohosting`} component={PrioHosting}></Route>
					<Route exact path={`/dashboard/priohosting/activation`} component={PrioLoadingScreen}></Route>
					<Route exact path="/dashboard" component={Modules}></Route>

					<Route path="/" component={Modules}></Route>
				</Switch>
			</ErrorBoundary>
		);
	}
}

const mapStateToProps = (state) => {
	return { auth: state.auth, user: state.data.user, bot: state.data.bot };
};

export default connect(mapStateToProps, { setAuth })(App);
